import React from 'react';
import { FileUploadListStyle as S } from './FileUploadList.style';
import { HStack, VStack } from 'components/layouts/primitives/Stack/Stack';
import { Text } from 'components/Text/Text';
import { Icon } from 'components/Icon/Icon';
import { PButtonIcon } from 'components/prime/PButton/PButtonIcon';
import { Box } from 'components/layouts/primitives/Box/Box';

export const FileUploadList: React.FC<{
  files: File[];
  onRemoveFile?: (file: File) => void;
  hideEmptyState?: boolean;
}> = ({ files, onRemoveFile, hideEmptyState }) => {
  if (!files?.length && !hideEmptyState) {
    return (
      <S.EmptyContainer>
        <VStack stretch align="center" justify="center">
          <Text as="span" color="neutral400" size="fontSizeXS" weight="medium" lineHeight="lineHeightSM">
            No files uploaded
          </Text>
        </VStack>
      </S.EmptyContainer>
    );
  }

  return (
    <VStack gap="gap1">
      {files.map((file, i) => (
        <S.Item key={i} padding={['paddingXXS', 'paddingSM']} radius="roundedMD">
          <HStack gap="gap2" align="center" splitAfterIdx={1}>
            <Box fit="content">
              <Icon size={20} icon="file07Line" color="neutral600" />
            </Box>
            <Text
              ellipsis
              color="neutral600"
              size="fontSizeSM"
              lineHeight="lineHeightMD"
              wordBreak="break-all"
            >
              {file.name}
            </Text>
            <Box fit="content">
              <PButtonIcon
                severity="primary"
                className="file-list-item-close"
                icon="xCloseLine"
                color="neutral600"
                shape="squircle"
                size="xs"
                onClick={() => onRemoveFile?.(file)}
              />
            </Box>
          </HStack>
        </S.Item>
      ))}
    </VStack>
  );
};
